import { knmErknmValidator } from 'KnmErknmPackage/MainModule/common/knmErknmValidator';
import { knmErpValidator } from 'KnmErpPackage/MainModule/common/knmErpValidator';
import { knmPmValidator } from 'KnmPmPackage/MainModule/common/knmPmValidator';

import { IKnmForm } from '../interfaces/IKnmForm';
import { KnmFormValidator } from '../types/KnmFormValidator';

export function knmFormValidator({ isErknm, isPm, ...props }: KnmFormValidator) {
  return (values: IKnmForm) => {
    if (isPm) {
      return knmPmValidator({ isErknm, values, ...props });
    }
    if (!isErknm) {
      return knmErpValidator({ values, ...props });
    }
    if (isErknm && !isPm) {
      return knmErknmValidator({ values, ...props });
    }
  };
}
